import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    switchRowContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    headerContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    footerContainer: {
        justifyContent: "flex-end",
        flexDirection: "row"
    },
    switchTextContainer: {
        flex: 1
    },
    selectBoxContainer: {
        width: "100%"
    },
    contentContainer: {
        maxHeight: 650,
        width: "100%"
    },
    container: {
        maxWidth: 600,
        width: "100%"
    },
    formContainer: {
        width: "100%"
    }
});
export default stylesheet;
